export default __webpack_public_path__ + "static/media/125.833e9946.jpg";